import React from "react";
import { ArrowRight } from "lucide-react";

// Forward arrow that points the reading direction (flips in Arabic).
// `nudge` slides it forward when its parent `.group` is hovered.
const DirArrow = ({ size = 16, nudge = false, className = "" }) => (
  <ArrowRight
    size={size}
    aria-hidden="true"
    className={`rtl:rotate-180 ${
      nudge ? "transition-transform duration-300 ease-out-expo group-hover:translate-x-1 rtl:group-hover:-translate-x-1" : ""
    } ${className}`}
  />
);

export default DirArrow;
